import { baseRoutes } from "../../../helpers";

const accessRoute = {
  DASHBOARD: {
    path: `${baseRoutes.adminBaseRoutes}/dashboard`,
  },
};

export default accessRoute;
  